import React from 'react'
import {TransitionGroup, CSSTransition} from 'react-transition-group'

export const Notes = ({notes, onRemove}) => {
  let sumPrice = 0
  let sumHeight = 0
  
    notes.map(note => (
      sumPrice += note.priceAll
    ))
    notes.map(note => (
      sumHeight += Number(note.netto)
      
    ))
    
    let height = sumHeight
    let maxheight = 1000000
    let onepercent = maxheight / 100
    
    let widthchek = height / onepercent
    console.log(widthchek)
  return(
  <form action="">
      <h5>Сумма скупки</h5>
      <a>{sumPrice}руб.</a>
     <div >
     
     
      </div>
      <hr/>
  <table class="table table-striped">
  <thead>
    <tr>
      <th scope="col">Наименование</th>
      <th scope="col">Масса брутто</th>
      <th scope="col">Масса нетто</th>
      <th scope="col">Тара</th>
      <th scope="col">Дата записи</th>
      <th scope="col">Дата выгрузки</th>
      <th scope="col">Сумма руб.коп.</th>
    </tr>
  </thead>
 
      <tbody>
      {notes.map(note => (
        <tr>
          <td>{note.title}</td>
          <td>{note.brutto}</td>
          <td>{note.netto}</td>
          <td>{note.tare}</td>
          <td>{note.date}</td>
          <td>{note.dateunload}</td>
          <td>{note.priceAll}</td>
         <td> <button
            type="button"
            className="btn btn-outline-danger btn-sm"
            onClick={() => onRemove(note.id)}
          >
            &times;
          </button></td>
         
        </tr>
        
        ))}
      </tbody>
    </table>
  </form>

  )
      }
